/**
 * Convert Fabric Y coordinate (top-left origin)
 * to PDF Y coordinate (bottom-left origin)
 */
export function fabricToPdfY(y, pageHeight) {
  return pageHeight - y;
}

/**
 * Convert Fabric line coordinates to PDF coordinates
 * Handles PDF page rotation internally
 */
export function fabricToPdfCoords({ x1, y1, x2, y2, page, width, height }) {
  const rotation = page.getRotation().angle;
  const pageSize = page.getSize();

  const canvasWidth = width;
  const canvasHeight = height;

  // PDF visible width / height (rotation aware)
  let pdfWidth = pageSize.width;
  let pdfHeight = pageSize.height;

  if (rotation === 90 || rotation === 270) {
    pdfWidth = pageSize.height;
    pdfHeight = pageSize.width;
  }

  // 1️⃣ map canvas → pdf (no scaling, just axis conversion)
  const mapX = (x) => (x / canvasWidth) * pdfWidth;
  const mapY = (y) => (y / canvasHeight) * pdfHeight;

  const cx1 = mapX(x1);
  const cy1 = mapY(y1);
  const cx2 = mapX(x2);
  const cy2 = mapY(y2);

  let px1, py1, px2, py2;

  // 2️⃣ rotation handling
  switch (rotation) {
    case 0:
      px1 = cx1;
      py1 = pdfHeight - cy1;
      px2 = cx2;
      py2 = pdfHeight - cy2;
      break;

    case 90:
      px1 = cy1;
      py1 = cx1;
      px2 = cy2;
      py2 = cx2;
      break;

    case 180:
      px1 = pdfWidth - cx1;
      py1 = cy1;
      px2 = pdfWidth - cx2;
      py2 = cy2;
      break;

    case 270:
      px1 = pdfHeight - cy1;
      py1 = pdfWidth - cx1;
      px2 = pdfHeight - cy2;
      py2 = pdfWidth - cx2;
      break;

    default:
      throw new Error('Unsupported PDF rotation');
  }

  return {
    x1: px1,
    y1: py1,
    x2: px2,
    y2: py2,
    rect: [
      Math.min(px1, px2),
      Math.min(py1, py2),
      Math.max(px1, px2),
      Math.max(py1, py2),
    ],
  };
}
